// 处方路由
export default [
    {
        path: "/other/contact",
        name: "otherContact",
        component: () => import("@/views/other/contact")
    },
    // 老版本迁移--联系客服
    {
        path: "/customerService",
        name: "customerService",
        component: () => import("@/views/other/contact")
    },
    {
        path: "/zhuisu",
        name: "zhuisu",
        component: () => import("@/views/other/yaopinzhuisu")
    },
    {
        path: "/home",
        name: "home",
        component: () => import("@/views/home/index")
    },
    {
        path: "/dept/list",
        name: "deptList",
        component: () => import("@/views/home/dept-list")
    },
    {
        path: "/home/content/list",
        name: "homeContentList",
        component: () => import("@/views/home/content-list")
    },
    {
        path: "/feedback/list",
        name: "feedback",
        component: () => import("@/views/feedback/list")
    },
    {
        path: "/feedback/add",
        name: "feedbackadd",
        component: () => import("@/views/feedback/add"),
        meta:{
            keepAlive:true
        }
    },
    {
        path: "/feedback/detail/:id",
        name: "feedbackDetail",
        component: () => import("@/views/feedback/detail")
    }
];



// WEBPACK FOOTER //
// ./src/router/other.js